import { api } from '../lib/api';

export interface ContractCalcBasic {
  id: number;
  userId: number;
  vatFoodDefault: number;
  bulkPriceKgDefault: number;
  ownCostKgDefault: number;
  updatedAt: string;
  createdAt: string;
}

export interface ContractCalcLine {
  id?: number;
  sortOrder: number;
  lineType: 'HONEY' | 'OTHER';
  title: string;
  honeyKgPerUnit: number;
  unitsPerYear: number;
  packagingCostPerUnit: number;
  sellPriceExVatPerUnit: number;
  qty: number;
  unitPriceExVat: number;
  direction: 'INCOME' | 'COST';
}

export interface ContractCalcSummary {
  id: number;
  customerName: string;
  year: number;
  vatFoodSnapshot: number;
  bulkPriceKgSnapshot: number;
  ownCostKgSnapshot: number;
  basicUpdatedAtAtSave: string | null;
  createdAt: string;
  updatedAt: string;
  isOutdated: boolean;
}

export interface ContractCalcDetail extends ContractCalcSummary {}

export const officeContractcalcApi = {
  getBasic: () => api.get<{ success: boolean; basic: ContractCalcBasic }>('/office/contractcalc/basic'),
  saveBasic: (payload: { vatFoodDefault: number; bulkPriceKgDefault: number; ownCostKgDefault: number }) =>
    api.post<{ success: boolean; basic: ContractCalcBasic }>('/office/contractcalc/basic', payload),
  list: () => api.get<{ success: boolean; basic: ContractCalcBasic; calcs: ContractCalcSummary[] }>('/office/contractcalc/calc'),
  get: (id: number) => api.get<{ success: boolean; basic: ContractCalcBasic; calc: ContractCalcDetail; lines: ContractCalcLine[] }>(`/office/contractcalc/calc/${id}`),
  save: (payload: {
    id: number;
    customerName: string;
    year: number;
    vatFoodSnapshot: number;
    bulkPriceKgSnapshot: number;
    ownCostKgSnapshot: number;
    basicUpdatedAtAtSave: string | null;
    lines: ContractCalcLine[];
  }) => api.post<{ success: boolean; id: number }>('/office/contractcalc/calc', payload),
  delete: (id: number) => api.delete<{ success: boolean }>(`/office/contractcalc/calc/${id}`),
  copy: (id: number, payload: { newCustomerName: string; newYear: number; useCurrentBasic: boolean }) =>
    api.post<{ success: boolean; id: number }>(`/office/contractcalc/calc/${id}/copy`, payload),
  applyBasic: (id: number) => api.post<{ success: boolean; basic: ContractCalcBasic }>(`/office/contractcalc/calc/${id}/apply-basic`),
};
